"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Flex = _interopRequireDefault(require("../../../Flex"));

var _Skeleton = _interopRequireDefault(require("../../../Skeleton"));

var _useTheme3 = _interopRequireDefault(require("../../../styles/useTheme"));

var _Text = _interopRequireDefault(require("../../../Text"));

var _useIsLoading = _interopRequireDefault(require("../../LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("../../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme3["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      marginBottom: spacing(0.5),
      alignItems: 'flex-start'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme3["default"]];
});

var StartDate = function StartDate(props) {
  var date = props.date,
      other = (0, _objectWithoutProperties2["default"])(props, ["date"]);

  var _useTheme2 = (0, _useTheme3["default"])(),
      spacing = _useTheme2.spacing;

  var isLoading = (0, _useIsLoading["default"])();
  var t = (0, _useTranslation["default"])();
  var classes = useStyles();
  var text = (0, _react.useMemo)(function () {
    var momentDate = (0, _moment["default"])(date);

    if (typeof date === 'undefined' || !momentDate.isValid()) {
      return '';
    }

    if (momentDate.isBefore()) {
      return t('as_soon_as_possible');
    }

    var textDate = momentDate.format('DD MMMM YYYY');
    return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_Text["default"], {
      variant: "paragraph",
      inactive: true
    }, t('from'), ' '), textDate);
  }, [date, t]);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: classes.root
  }, other), isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    width: spacing(16)
  }) : (0, _core.jsx)(_Text["default"], other, text));
};

__signature__(StartDate, "useTheme{{ spacing }}\nuseIsLoading{isLoading}\nuseTranslation{t}\nuseStyles{classes}\nuseMemo{text}", function () {
  return [_useTheme3["default"], _useIsLoading["default"], _useTranslation["default"], useStyles];
});

var _default = StartDate;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/StartDate.tsx");
  reactHotLoader.register(StartDate, "StartDate", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/StartDate.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/StartDate.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();